const updates = [
  {
    id: 1,
    time: '10:42',
    tag: '突发',
    tagColor: 'bg-primary-500',
    title: '某影视公司CEO被带走协助调查，公司股价盘中暴跌',
    summary: '据知情人士透露，可能与近期娱乐圈税务专项整治行动有关。该公司旗下有多位一线艺人。',
  },
  {
    id: 2,
    time: '09:18',
    tag: '跟进',
    tagColor: 'bg-accent-500',
    title: '昨日爆料帖当事人发布律师函，称将通过法律途径维权',
    summary: '涉及昨日某热门爆料帖的当事人工作室发布正式声明，表示将通过法律手段追究造谣者责任。',
  },
  {
    id: 3,
    time: '08:05',
    tag: '独家',
    tagColor: 'bg-secondary-500',
    title: '知名经纪人深夜发朋友圈暗示将有大料，圈内震动',
    summary: '该经纪人曾带出多位顶流艺人，朋友圈文案"该来的总会来"引发多方猜测。',
  },
  {
    id: 4,
    time: '昨日 23:30',
    tag: '热议',
    tagColor: 'bg-accent-500',
    title: '综艺选手淘汰内幕再添实锤，评委言论被扒出打脸',
    summary: '网友扒出评委往期采访中的言论与节目中表现存在明显矛盾，节目公信力再遭质疑。',
  },
  {
    id: 5,
    time: '昨日 21:15',
    tag: '爆料',
    tagColor: 'bg-primary-500',
    title: '某品牌代言人即将更换，现任代言人合约到期不续',
    summary: '业内人士透露，品牌方对现任代言人近期的负面新闻有所不满，已开始接触替代人选。',
  },
  {
    id: 6,
    time: '昨日 18:40',
    tag: '数据',
    tagColor: 'bg-secondary-500',
    title: '上半年娱乐热搜榜单出炉，这家工作室买热搜花费最高',
    summary: '第三方数据分析平台公布上半年热搜购买统计，某艺人工作室以超出第二名近一倍的花费登顶。',
  },
  {
    id: 7,
    time: '昨日 15:22',
    tag: '独家',
    tagColor: 'bg-accent-500',
    title: '某热门剧组内部矛盾激化，男女主角片场零交流',
    summary: '据剧组工作人员匿名透露，两位主演在片场已多日互不理睬，拍摄进度严重受影响。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              最新快讯
            </h2>
            <p className="text-sm text-foreground-500">7x24小时滚动更新的娱乐八卦快报</p>
          </div>
          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden sm:block"></div>
            <div className="space-y-0">
              {updates.map((u, idx) => (
                <div key={u.id} className="relative flex gap-6 pb-8 last:pb-0">
                  {/* Dot */}
                  <div className="hidden sm:flex items-start pt-1 flex-shrink-0">
                    <div className={`w-[38px] h-[38px] rounded-full border-4 border-background-100 ${idx === 0 ? 'bg-primary-500' : 'bg-background-200'} flex items-center justify-center relative z-10`}>
                      {idx === 0 && <i className="ri-flashlight-line text-white text-sm"></i>}
                    </div>
                  </div>
                  {/* Content */}
                  <div className="flex-1 bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-colors duration-200">
                    <div className="flex items-center gap-2 mb-2 flex-wrap">
                      <span className="text-xs text-foreground-400 font-mono">{u.time}</span>
                      <span className={`px-2 py-0.5 ${u.tagColor} text-white text-xs font-medium rounded`}>
                        {u.tag}
                      </span>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">{u.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{u.summary}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}